import React from 'react';
import '../main.css'; // CSS styles
import facility1 from '../images/facility1.jpeg';
import tennis1 from '../images/tennis1.jpeg';
import walk1 from '../images/walk1.jpeg';
import astro1 from '../images/astro1.jpeg'

function PrimaryFacilities() {
  return (
    <div className="container mt-4">

      {/* 🖼️ Background Image Section with Text */}
      <div
        className="text-section-with-bg text-white p-4 mb-5"
        style={{
          backgroundImage: `url(${facility1})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      >
        {/* Overlay */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(17, 114, 204, 0.5)',
            zIndex: 1,
            borderRadius: '8px',
          }}
        />
        {/* Content above overlay */}
    <div style={{ position: 'relative', zIndex: 2 }}>
  <h1>Our Facilities</h1>
  <p>
    At Highlands Primary School, we believe that learning goes beyond the classroom. A well-rounded education includes not only strong academics, but also physical development, teamwork, and healthy habits.
  </p>

  <p>
    Our school is proud to offer a wide range of high-quality sports facilities designed specifically for our learners. These include a well-maintained <strong>astroturf field</strong> for various sports activities, a <strong>netball court</strong>, a <strong>tennis court</strong>, and a spacious <strong>soccer field</strong>. These areas allow students to engage in physical education, team sports, and fun recreational activities in a safe, structured environment.
  </p>

  <p>
    We take sports seriously as part of developing well-rounded, confident children. Through regular PE lessons and extracurricular sports, our learners gain not only fitness but also skills such as discipline, cooperation, and resilience.
  </p>

  <p>
    Highlands Primary is committed to creating a vibrant, active school community where every child is encouraged to grow — academically, socially, and physically.
  </p>
</div>

      </div>

      {/* 🔽 Bottom 3 Images (Custom images) */}
      <div className="row mt-4">
        <div className="col-md-4 mb-3">
          <img
            src={walk1}
            alt="Walkway"
            className="img-fluid rounded"
          />
        </div>
        <div className="col-md-4 mb-3">
          <img
            src={tennis1}
            alt="Tennis Court"
            className="img-fluid rounded"
          />
        </div>
        <div className="col-md-4 mb-3">
          <img
            src={astro1}
            alt="Astro Turf"
            className="img-fluid rounded"
          />
        </div>
      </div>

    </div>
  );
}

export default PrimaryFacilities;
